module.exports = __webpack_public_path__ + "static/media/rounded-rect-tertiary.c0e3296c.png";